import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./HtmlEditor.css";

function HtmlEditor({ value, onChange }) {
  const modules = {
    toolbar: {
      container: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
    },
    clipboard: {
      matchVisual: false,
    },
  };

  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "list",
    "bullet",
    "indent",
    "align",
    "link",
    "image",
    "video",
  ];

  const cleanHTML = (dirtyHTML) => {
    if (!dirtyHTML) return "";

    let clean = dirtyHTML
      .replace(/<span[^>]*>/g, "")
      .replace(/<\/span>/g, "")
      .replace(/<p><br><\/p>/g, "")
      .replace(/style="[^"]*"/g, "")
      .replace(/class="[^"]*"/g, "")
      .replace(/<img[^>]*>/g, (img) => {
        if (!img.includes('style="')) {
          return img.replace(
            "<img",
            '<img style="max-width: 100%; height: auto;"'
          );
        }
        return img;
      });

    return clean.trim();
  };

  const handleChange = (content) => {
    onChange(cleanHTML(content));
  };

  return (
    <div className="html-editor">
      <ReactQuill
        theme="snow"
        modules={modules}
        formats={formats}
        value={value}
        onChange={handleChange}
        placeholder="Tu contenido traducido aquí..."
      />
    </div>
  );
}
export default HtmlEditor;
